module.exports = __webpack_public_path__ + "img/MX.e211fcea.svg";